export let OPERATIONS = [
  {
    id: 'equals',
    text: 'is',
  },
  {
    id: 'notEquals',
    text: 'is not',
  },
]
